import { MatchDetailItemFragment } from '@amf/shared/types/graphql';
import { useTranslate } from '@tolgee/react';
import useMatch from '@amf/shared/components/match/hooks/useMatch';

type Props = {
  match: MatchDetailItemFragment;
};

function MatchJumbotronStatus({ match }: Props) {
  const { t } = useTranslate();
  const { match: live } = useMatch(match.id, match.live);

  if (!live) return null;
  return (
    <div className='MatchJumbotron__status'>
      <div className='MatchJumbotron__statusInner'>{t(`match.event.status.${live.status}`)}</div>
    </div>
  );
}

export default MatchJumbotronStatus;
